<template>
  <kst-section items-mode>
    <kst-table input-mode :data="items">
      <b-table-column
        v-slot="{ column, row }"
        field="DispatchID"
        :label="RinvItemCatalog.DispatchID.ColumnLabel"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="RinvItemCatalog"
        />
      </b-table-column>

      <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
        <template #header>
          <kst-header-blank />
        </template>
        <template #default="{ row }">
          <kst-tooltip info-mode>
            <template #content>
              <kst-list info-mode :items="Model.Details.getItemInfo(row)"/>
            </template>
            <kst-icon info-mode/>
          </kst-tooltip>
        </template>
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-packaging"
        field="Packaging"
        :label="RinvItemCatalog.Packaging.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="RinvItemCatalog"
        />
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-qty"
        field="Quantity"
        :label="RinvItemCatalog.Quantity.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="RinvItemCatalog"
        />
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-price"
        field="SellPrice"
        :label="RinvItemCatalog.SellPrice.Label"
      >
        <kst-output box-off field-only
          :field="column.field" :data="row" :catalog="RinvItemCatalog"
        />
      </b-table-column>

      <b-table-column
        v-if="hasItemLevelDisc && hasDiscountedItem"
        v-slot="{ column, row }"
        cell-class="ks-col-disc-value"
        field="DiscPercent"
        label="Diskon"
      >
        <template v-if="row.DiscPercent > 0">
          <kst-output field-only field="DiscPercent" :data="row" :catalog="RinvItemCatalog"/>
        </template>
        <template v-else-if="row.DiscValue > 0">
          <kst-output field-only field="DiscValue" :data="row" :catalog="RinvItemCatalog"/>
        </template>
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-subtotal"
        field="TotalAfterDisc"
        :label="RinvItemCatalog.Total.Label"
      >
        <kst-output box-off field-only
          field="TotalAfterDisc" :data="getRowDisplay(row)" :catalog="RinvItemCatalog"
        />
      </b-table-column>
    </kst-table>
  </kst-section>
</template>

<script>
import AppModuleAttr from "../../../services/App/AppModuleAttr.js";
import Model from "../RinvModel.js";
import RinvItemCatalog from "../RinvItemCatalog.js";

export default {
  props: {
    items: Array
  },
  data: () => ({
    Model: Model,
    RinvItemCatalog: RinvItemCatalog
  }),
  computed: {
    hasItemLevelDisc() {
      return this.$kst.Access.hasModuleAttr(AppModuleAttr.ItemLevelDisc_Act_List);
    },
    // tampilkan kolom diskon hanya bila minimal satu baris item berdiskon
    hasDiscountedItem() {
      return Array.isArray(this.items) && this.items.some(
        (row) => (row.DiscPercent || 0) > 0 || (row.DiscValue || 0) > 0
      );
    }
  },
  methods: {
    // Sub Total per baris: pakai TotalAfterDisc jika tersimpan, fallback
    // ReturnInvoiceItemsTotal / Total (Qty x Harga) agar tidak kosong untuk
    // baris tanpa diskon item maupun dokumen lama tanpa TotalAfterDisc.
    getRowDisplay(row) {
      const totalAfterDisc = row.TotalAfterDisc !== null &&
        row.TotalAfterDisc !== undefined ? row.TotalAfterDisc : null;
      const itemTotal = row.ReturnInvoiceItemsTotal !== null &&
        row.ReturnInvoiceItemsTotal !== undefined
        ? row.ReturnInvoiceItemsTotal : row.Total;

      return {
        ...row,
        TotalAfterDisc: totalAfterDisc !== null
          ? totalAfterDisc
          : (itemTotal !== null && itemTotal !== undefined
              ? itemTotal
              : (row.Quantity || 0) * (row.SellPrice || 0))
      };
    }
  }
}
</script>